import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { PointOptionsObject } from 'highcharts';
import { Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { CompanyService } from 'src/app/root/company.service';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

@Component({
  selector: 'lohi-lost-earnings-by-driver-chart',
  templateUrl: './lost-earnings-by-driver-chart.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LostEarningsByDriverChartComponent implements OnInit, OnDestroy {
  private destroy$$ = new Subject();
  public dateFormat = 'M/dd/yyyy';
  public labels: Array<string>;

  public chart: Chart;

  constructor(private companyService: CompanyService, private cd: ChangeDetectorRef, private router: Router) {}

  public ngOnInit() {
    this.companyService.lostEarningsByDriver$.pipe(takeUntil(this.destroy$$)).subscribe(async (entries) => {
      if (!entries || !entries.length) {
        return;
      }
      const metrics = await this.companyService.companyMetrics30Day$
        .pipe(
          filter((m) => !!m),
          take(1),
        )
        .toPromise();
      const labels = entries.map((entry) => entry.name);
      this.chart = new Chart({
        chart: {
          type: 'column',
        },
        title: {
          align: 'left',
          useHTML: true,
          text: `<div class="text-lg font-bold">Average Lost Carrier Revenue Per Shift <span class="text-blue-500">${
            metrics.daysOfHistory || 30
          }d</span></div>`,
        },
        credits: {
          enabled: false,
        },
        yAxis: [
          {
            labels: {
              enabled: false,
            },
            tickInterval: 0,
            title: { text: null },
          },
          {
            title: { text: 'Dollars' },
          },
        ],
        plotOptions: {
          series: {
            events: {
              click: (event) => {
                // @ts-ignore
                if (!event.point.custom.userId) {
                  return;
                }
                // @ts-ignore
                this.router.navigate(['drivers', event.point.custom.userId]);
              },
            },
          },
        },
        xAxis: {
          type: 'category',
          categories: labels,
          visible: true,
        },
        series: [],
        tooltip: {
          formatter() {
            return (
              `<span class="font-bold" style="color: ${this.point.color}">` +
              this.series.name +
              '</span> ' +
              currencyFormatter.format(this.y)
            );
          },
        },
      });
      const missedEarnings: Array<[string, number] | PointOptionsObject> = [];
      for (const entry of entries) {
        missedEarnings.push({
          label: entry.name,
          custom: {
            userId: entry.lohiUserId,
          },
          y: entry.missedEarnings / 100,
        });
      }
      this.chart.addSeries(
        {
          name: 'Average Lost Carrier Revenue Per Shift',
          type: 'column',
          color: '#EF6048',
          data: missedEarnings,
          yAxis: 1,
        },
        true,
        true,
      );
      this.cd.markForCheck();
    });
  }

  public ngOnDestroy() {
    this.destroy$$.next();
    this.destroy$$.unsubscribe();
  }
}
